export type KrakenPair = string;
export type KrakenPrice = string;
export type KrakenAmount = string;

export const getPair = (base: Currency, counter: Currency): KrakenPair => `${base}/${counter}`;
